<template>
  <v-dialog
    :value="visible"
    max-width="45rem"
    persistent
    scrollable
    @input="close"
  >
    <v-card :loading="loading" :disabled="loading">
      <v-card-title>Edit Catalogue Category</v-card-title>

      <v-divider class="w-100" />

      <v-card-text v-if="options" class="pt-2" style="height: 625px;">
        <v-text-field
          v-model="position"
          class="mb-5"
          label="Position"
          outlined
          dense
          hide-details="auto"
          type="number"
        />

        <div
          v-for="(option, key) in options"
          :key="key"
        >
          <div>
            <v-text-field
              v-model="options[key].name"
              :label="key.toUpperCase()"
              outlined
              dense
            />
          </div>
        </div>
      </v-card-text>

      <v-divider class="w-100" />

      <v-card-actions class="justify-end">
        <v-btn
          text
          color="error"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :elevation="0"
          :disabled="isSaveBtnDisabled"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep'
import _values from 'lodash/values'

export default {
  name: 'DialogEditCatalogueCategory',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    catalogueCategory: {
      validator: value => typeof value === 'object' || value === null,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      options: null,
      position: 0
    }
  },

  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    isSaveBtnDisabled () {
      return _values(this.options)
        .reduce((a, item) => {
          return a.concat(item.name)
        }, [])
        .some(value => value === '')
    }
  },

  watch: {
    visible (value) {
      if (value) {
        this.setCatalogueCategory()
        this.position = this.catalogueCategory.position
      }
    }
  },

  methods: {
    async save () {
      try {
        this.loading = true
        await this.$http.put(`admin/catalogue/categories/${this.catalogueCategory.id}`, { data: this.options, position: this.position })
        this.$emit('finished')
        this.close()
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },

    setCatalogueCategory () {
      this.options = _cloneDeep(this.catalogueCategory.options)
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
